import { Component, ElementRef, Input, ViewChild, } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { SystemFieldsService } from "@app/services/system-fields/system-fields.service";
import { CovalentCodeEditorModule } from "@covalent/code-editor";
import { NotificationService } from "../notification/notification.service";

@Component({
  selector: 'app-replace-variables',
  templateUrl: './replace-variables.component.html',
  styleUrls: ['./replace-variables.component.scss']
})
export class replaceVariables {
  @Input() form;
  @Input() nameFormControl;
  @Input() variables;
  @Input() title;
  internalForm: FormGroup;

  @ViewChild('editor', { static: false }) editor: CovalentCodeEditorModule;

  constructor(
    public systemFieldService: SystemFieldsService,
    private serviceNotification: NotificationService
  ) { }

  addVar(variable) {
    const text = this.getVariableName(variable);
    this.copyTextToClipboad(text);
    this.pasteText(text);
    this.notify();
  }

  private copyTextToClipboad(text) {
    const element = document.createElement('textarea');
    document.body.appendChild(element);
    element.value = text;
    element.select();
    document.execCommand('copy');
    document.body.removeChild(element);
  }

  private getVariableName(variable) {
    return `#{@${variable.label}-${variable.key}@}`;
  }

  private pasteText(text) {
    const editor = this.editor['_editor'];
    setTimeout(() => {
      editor.focus();
      const selection = editor.getSelection();
      editor.executeEdits("clipboard", [{
        range: selection,
        text: text,
        forceMoveMarkers: true,
      }]);
    }, 0)
  }

  private notify() {
    this.serviceNotification.notificationOpen(
      'Variável adicionada',
      'Ok',
      'success',
      2000
    );
  }
}
